import { styled } from 'styled-components'
import { Layout } from '../styled'
import { Typography } from 'antd'
import { SMALL_LAYOUT_MAX_WIDTH } from '../constants'

export const StyledFooter = styled(Layout.Footer)`
  display: flex;
  height: 259px;
  width: 100%;

  // hide footer on mobile
  @media (max-width: ${SMALL_LAYOUT_MAX_WIDTH}) {
    display: none;
  }
`

export const StyledText = styled(Typography.Text)`
  color: white;
  font-size: 18px;
  font-weight: 600;
  line-height: 88%;
`

export const StyledRightsReservedText = styled(Typography.Text)`
  color: white;
  font-size: 15px;
  font-weight: 600;
  line-height: 88%;
  opacity: 0.9;
`
